import {
  FETCH_ORIGINATORS_REQUEST,
  FETCH_ORIGINATORS_SUCCESS,
  FETCH_ORIGINATORS_FAILURE,
  SET_ORIGINATORID,
  SET_ORIGINATORNAME,
  SET_SEARCHSTRING,
  CLEANUP,
} from "./selectOriginatorType";

import { searchOriginatorNameForSelectorWithCancelSignal } from "../../api/api";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setSearchString = (searchString) => {
  return {
    type: SET_SEARCHSTRING,
    searchString: searchString,
  };
};

export const setOriginatorId = (originatorId) => {
  return {
    type: SET_ORIGINATORID,
    originatorId: originatorId,
  };
};

export const setOriginatorName = (originatorName) => {
  return {
    type: SET_ORIGINATORNAME,
    originatorName: originatorName,
  };
};

const fetchOrignatorsRequest = () => {
  return {
    type: FETCH_ORIGINATORS_REQUEST,
  };
};

const fetchOrignatorsSuccess = (payload) => {
  return {
    type: FETCH_ORIGINATORS_SUCCESS,
    payload: payload,
  };
};

const fetchOrignatorsFailure = (error) => {
  return {
    type: FETCH_ORIGINATORS_FAILURE,
    payload: error,
  };
};

export const fetchOriginators = (value, cancelSignal) => {
  return async (dispatch) => {
    dispatch(fetchOrignatorsRequest());
    try {
      var response = await searchOriginatorNameForSelectorWithCancelSignal(
        value,
        cancelSignal
      );

      // return data
      dispatch(fetchOrignatorsSuccess(response));
    } catch (error) {
      dispatch(fetchOrignatorsFailure(error.message));
    }
  };
};
